import request from '@/config/axios'

export interface DistRankConditionVO {
  metric: string
  op?: string
  threshold: number
  refRankCode?: string
  sort?: number
  enabled?: boolean
}

export interface DistRankVO {
  id?: number
  track?: string
  code: string
  name: string
  icon?: string
  sort: number
  l1Rate: number
  l2Rate: number
  enabled: boolean
  remark?: string
  conditions?: DistRankConditionVO[]
}

export interface DistRankUserVO {
  userId: number
  userNickname?: string
  rankId?: number
  rankCode?: string
  rankName?: string
  level1Count?: number
  level2Count?: number
  selfCommission?: number
  rankTime?: string
  rankLockedUntil?: string
}

export const getDistRankList = (track = 'MEMBER') =>
  request.get<DistRankVO[]>({ url: '/bosscircle/dist-rank/list', params: { track } })

export const getDistRank = (id: number) =>
  request.get<DistRankVO>({ url: '/bosscircle/dist-rank/get', params: { id } })

export const createDistRank = (data: DistRankVO) =>
  request.post({ url: '/bosscircle/dist-rank/create', data })

export const updateDistRank = (data: DistRankVO) =>
  request.put({ url: '/bosscircle/dist-rank/update', data })

export const getDistRankUserPage = (params: {
  pageNo?: number
  pageSize?: number
  userNickname?: string
  rankId?: number
}) => request.get<{ list: DistRankUserVO[]; total: number }>({ url: '/bosscircle/dist-rank/user/page', params })

export const adjustDistRankUser = (data: {
  userId: number
  rankId: number
  remark?: string
  rankLockedUntil?: string
}) => request.put({ url: '/bosscircle/dist-rank/user/adjust', data })

export const recalcDistRankUser = (userId: number) =>
  request.post({ url: '/bosscircle/dist-rank/user/recalc', params: { userId } })
